export class MoedaUtils {

  public static pontoToMoeda(pontos: number, indice: number): number {
    return pontos * indice;
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/utils/moeda-utils.ts